module.exports = {"failed":"Die Zugangsdaten konnten nicht gefunden werden.","throttle":"Zu viele Logins innerhalb von kurzer Zeit. Bitte versuche es in :seconds Sekunden nochmal."};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/de/auth.php
// module id = IYhh
// module chunks = 1